import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { addProduct } from '../../redux/productItems/actions';
import store from '../../redux/store';

export default function
  () {

    const dispatch = useDispatch();
  const [state, setState] = useState({
    productName: '',
    category: '',
    imageUrl: '',
    price: 0,
    quantity: 0,
  })


  const inputHandler = (e) => {
    const { name, value } = e.target;
    setState(prevState => ({
      ...prevState,
      [name]: value
    }));
    //console.log(state); // Log the current state of the store
  }

  const submitHandler = (event) => {
    event.preventDefault();

    if (state.productName === '' || state.category === '' || state.imageUrl === '' || state.quantity <= 0 || state.price < 0) {
      if (state.quantity <= 0) {
        alert('Quantity field can not be zero.');  
      }else if (state.price < 0) {
        alert('Price field can not be negetive.');  
      }else{
        alert('All fields are required');
      }
    } else {
      dispatch(addProduct({
        productName: state.productName,
        category: state.category,
        imageUrl: state.imageUrl,
        price: state.price,
        quantity: state.quantity,
      }));
      //console.log(store.getState()); // Log the current state of the store

      setState({
        productName: '',
        category: '',
        imageUrl: '',
        price: 0,
        quantity: 0,
      })
    }
  }

  return (
    <div>
      <div className="formContainer">
        <h4 className="formTitle">Add New Product</h4>
        <form className="space-y-4 text-[#534F4F]" onSubmit={submitHandler} id="lws-addProductForm">
          {/* <!-- product name --> */}
          <div className="space-y-2">
            <label htmlFor="lws-inputName">Product Name</label>
            <input className="addProductInput" id="lws-inputName" name='productName' onChange={inputHandler} value={state.productName} type="text" required />
          </div>
          {/* <!-- product category --> */}
          <div className="space-y-2">
            <label htmlFor="lws-inputCategory">Category</label>
            <input className="addProductInput" id="lws-inputCategory" name='category' onChange={inputHandler} value={state.category} type="text" required />
          </div>
          {/* <!-- product image url --> */}
          <div className="space-y-2">
            <label htmlFor="lws-inputImage">Image Url</label>
            <input className="addProductInput" id="lws-inputImage" name='imageUrl' onChange={inputHandler} value={state.imageUrl} type="text" required />
          </div>
          {/* <!-- price & quantity container --> */}
          <div className="grid grid-cols-2 gap-8 pb-4">
            {/* <!-- price --> */}
            <div className="space-y-2">
              <label htmlFor="ws-inputPrice">Price</label>
              <input className="addProductInput" type="number" name='price' onChange={inputHandler} value={state.price} id="lws-inputPrice" required />
            </div>
            {/* <!-- quantity --> */}
            <div className="space-y-2">
              <label htmlFor="lws-inputQuantity">Quantity</label>
              <input className="addProductInput" type="number" name='quantity' onChange={inputHandler} value={state.quantity} id="lws-inputQuantity" required />
            </div>
          </div>
          {/* <!-- submit form --> */}
          <button type="submit" id="lws-inputSubmit" className="submit">Add Product</button>
        </form>
      </div>
    </div>
  )
}
